












































import { Component, Vue } from "vue-property-decorator";

@Component
export default class HomeHeader extends Vue {
    public login() {
        this.$auth.loginWithRedirect();
    }
    public logout() {
        this.$auth.logout({
            returnTo: window.location.origin,
        });
    }
    public items: Array<{
        text: string;
        disabled: boolean;
        to: string;
    }> = [
        {
            text: "header.home",
            disabled: false,
            to: "/",
        },
        {
            text: "header.tools",
            disabled: false,
            to: "/tools",
        },
        {
            text: "header.test",
            disabled: false,
            to: "test",
        },
        {
            text: "header.pricing",
            disabled: false,
            to: "pricing",
        },
    ];
    public get linkClasses(): string {
        if (this.$vuetify.breakpoint.mdAndDown) {
            return "links text-body-2 text-md-body-1 px-0 py-1";
        } else return "links text-body-2 text-md-body-1";
    }
}
